// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// These values are public and safe to expose in the client
const SUPABASE_URL = "https://uubpxlhfkxqjrsgnwlzh.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV1YnB4bGhma3hxanJzZ253bHpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU5MTI5OTQsImV4cCI6MjA1MTQ4ODk5NH0.3A02BEvvXSvJuuhR5qdrcOP7W6fpOPkE_t2Mj0JD2d8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);